import React from 'react';
import WalkthroughControls from './WalkthroughControls';

/**
 * WalkthroughTooltip Component
 * Displays step information and navigation controls in a popover-style tooltip
 */
const WalkthroughTooltip = ({
  step,
  position,
  currentStepIndex,
  totalSteps,
  isFirstStep,
  isLastStep,
  onPrevious,
  onNext,
  onClose
}) => {
  if (!step || !position) {
    return null;
  }

  const tooltipStyle = {
    position: 'fixed',
    top: position.top !== 'auto' ? `${position.top}px` : 'auto',
    left: position.left !== 'auto' ? `${position.left}px` : 'auto',
    right: position.right !== 'auto' ? `${position.right}px` : 'auto',
    bottom: position.bottom !== 'auto' ? `${position.bottom}px` : 'auto',
    width: '320px',
    maxWidth: 'calc(100vw - 40px)',
    backgroundColor: '#ffffff',
    border: '1px solid #dddbda',
    borderRadius: '4px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.15)',
    padding: '16px',
    zIndex: 9999,
    transition: 'all 0.3s ease-in-out'
  };

  const titleStyle = {
    fontSize: '16px',
    fontWeight: '700',
    color: '#080707',
    marginBottom: '8px',
    lineHeight: '1.25'
  };

  const descriptionStyle = {
    fontSize: '14px',
    color: '#3e3e3c',
    marginBottom: '16px',
    lineHeight: '1.5'
  };

  return (
    <div style={tooltipStyle}>
      {/* Step title */}
      {step.title && (
        <div style={titleStyle}>
          {step.title}
        </div>
      )}

      {/* Step description */}
      {step.description && (
        <div style={descriptionStyle}>
          {step.description}
        </div>
      )}

      {/* Navigation controls */}
      <WalkthroughControls
        currentStepIndex={currentStepIndex}
        totalSteps={totalSteps}
        isFirstStep={isFirstStep}
        isLastStep={isLastStep}
        onPrevious={onPrevious}
        onNext={onNext}
        onClose={onClose}
      />
    </div>
  );
};

export default WalkthroughTooltip;
